import { AnalyticsEventsJourney } from 'core/constants/analytics-event-journey';
import { ProfileUser } from 'core/models/account/profile';
import { Util } from 'utils/common.utils';

export const AnalyticsEventStore = {
  user: {} as any,
  isInitialized: false,
  events: {
    current: [],
    previous: []
  } as any,

  get currentJourney() {
    return this.events.current[0]?.journey
  },

  initialize: (userDetails: ProfileUser, locale: string, customerNumber: string, countryName: string, countryCodeThreeChar: string) => {
    if (AnalyticsEventStore.isInitialized) {
      return Promise.resolve(AnalyticsEventStore)
    }

    AnalyticsEventStore.user = {
      user_email: Util.convertToHash(userDetails.email),
      user_phone: userDetails?.listOfPhoneNumber?.length && userDetails.listOfPhoneNumber.length > 0 ? Util.convertToHash(`${userDetails.listOfPhoneNumber[0].countryCode}${userDetails.listOfPhoneNumber[0].number}`) : '',
      user_first_name: Util.convertToHash(userDetails.firstName),
      user_last_name: Util.convertToHash(userDetails.surname),
      user_zipcode: Util.convertToHash(countryCodeThreeChar),
      user_country: Util.convertToHash(countryName),
      user_id: Util.convertToHash(customerNumber),
      user_city: '',
      user_region: Util.convertToHash(locale),
    };
    AnalyticsEventStore.isInitialized = true;
    const w = window as any;
    w.dataLayer = w.dataLayer || [
      []
    ];

    return Promise.resolve(AnalyticsEventStore);
  },

  changeEvents: (event: any) => {
    AnalyticsEventStore.events.current.push(event);
  },

  addEvent: (journey: any, eventKey: any, info: any, validate?: boolean) => {
    if (AnalyticsEventStore.currentJourney) {
      if (validate && AnalyticsEventStore.events.current.find((event: any) => event.key === eventKey)) {
        return;
      }
      AnalyticsEventStore.events.current.push({ key: eventKey, ...AnalyticsEventsJourney[AnalyticsEventStore.currentJourney][eventKey]({ ...info, user: AnalyticsEventStore.user }) });
      AnalyticsEventStore.setDataLayer(AnalyticsEventsJourney[AnalyticsEventStore.currentJourney][eventKey]({ ...info, user: AnalyticsEventStore.user }));
    } else {
      if (AnalyticsEventStore.events.current[0]?.journey !== eventKey) {
        AnalyticsEventStore.events.previous = { ...AnalyticsEventStore.events.current };
        AnalyticsEventStore.events.current.push({ key: journey, ...AnalyticsEventsJourney[journey][eventKey]({ ...info, user: AnalyticsEventStore.user }) });
        AnalyticsEventStore.setDataLayer(AnalyticsEventsJourney[journey][eventKey]({ ...info, user: AnalyticsEventStore.user }));
      }
    }
  },

  setDataLayer: (analyticsEvent: any) => {
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push(analyticsEvent);

    w.dataLayer.push({
      event: 'Reset_Ecom',
      ecommerce: undefined
    })
  }
}